export default function(){
    this.main.customObject = function(cb){
        if(this.rule.hasOwnProperty("requiredIf")){
            let required = this.isRequiredIf();
            if(required && this.value == null){
                this.raise(this.reasons.required, this.rule.message);
            }
        }
        cb();
    };
}
